import * as React from 'react';

import cx from 'classnames';

import { IconCheckmark } from '~shared/components/icons/micro';

import { ResultsGridCornerMask } from './ResultsGridCornerMask';

interface CellProps {
  children: React.ReactNode;
  displayScore: React.ReactNode;
  showName: boolean;
  index: number;
  present: boolean;
  completed: boolean;
  isRosteredRoom: boolean;
  isActivityInProgress: boolean;
}

type Status = Pick<CellProps, 'present'>;

function StatusIndicator({ present }: Status): React.ReactElement {
  return present ? (
    <div className="w-4 h-4 bg-green-600 rounded-pill"></div>
  ) : (
    <div className="w-4 h-px bg-blue-800"></div>
  );
}

export function ResultsParticipantCell({
  children,
  showName,
  index,
  present,
  completed,
  displayScore: scoreDisplay,
  isRosteredRoom,
  isActivityInProgress,
}: CellProps): React.ReactElement {
  const wrapperClass = cx(
    'relative flex flex-grow items-center justify-between h-full px-4 rounded-4px',
    index % 2 ? 'bg-white' : 'bg-grey-50'
  );
  const nameTextClass = cx(
    'text-sm font-400 leading-8 text-blue-900',
    !showName && 'tracking-widest'
  );

  return (
    <div className={wrapperClass}>
      <ResultsGridCornerMask />
      <div className="flex items-center max-w-40 md:max-w-50">
        {isActivityInProgress && isRosteredRoom && (
          <div data-testid="presence">
            <StatusIndicator present={present} />
          </div>
        )}
        <div className={`w-full ${isRosteredRoom && 'pl-4'} text-left`}>
          <div className="truncate">
            <span data-student-name className={nameTextClass}>
              {showName ? children : '•••••••'}
            </span>
          </div>
        </div>
      </div>
      <div className="flex items-center justify-end">
        {completed ? (
          <div data-testid="completed-check" className="text-blue-900">
            <IconCheckmark />
          </div>
        ) : null}
        <div className="pl-2">
          <span
            data-student-score
            className="text-sm font-400 leading-8 text-blue-900 text-right"
          >
            {scoreDisplay}
          </span>
        </div>
      </div>
    </div>
  );
}
